
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listing/[id]",
      function () {
        return require("private-next-pages/listing/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listing/[id]"])
      });
    }
  